import 'whatwg-fetch';

import Component from '../site/Component';

/**
 * Component for Mailchimp popup component.
 */
export default class MailchimpPopup extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  /* eslint-disable class-methods-use-this */
  start() {
    function getCheckedValues() {
      return Array.from(document.querySelectorAll(
        '.mailchimp-options__interest-groups input[type="checkbox"]'))
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
    }
    const mcSubmit = document.getElementById('mc-embedded-subscribe');
    if (mcSubmit) {
      mcSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        const intGroups = getCheckedValues();
        const groups = `&interest_groups=${intGroups}`;
        const mceEmailValue = document.getElementById('mce-EMAIL').value;
        const mceEmail = `&email_address=${mceEmailValue}`;
        const mceAction = 'action=hachette_mailchimp_update';
        const nonce = `&nonce=${window.mailchimpPopup.nonce}`;
        const updateBody = `${mceAction}${nonce}${mceEmail}${groups}`;
        const chimpPopup =
          document.getElementById('mailchimp_options_popup');
        fetch(window.mailchimpPopup.ajax_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;',
          },
          credentials: 'include',
          body: updateBody,
        })
        .then((data) => data.json())
        .then((response) => {
          const message =
            this.element.querySelector(this.elements.message);
          if ('error' === response.results) {
            mcSubmit.style.display = 'none';
            message.textContent = window.mailchimpPopup.error;
          } else {
            message.textContent = window.mailchimpPopup.success;
            window.setTimeout(() => {
              chimpPopup.classList.remove('show');
            }, 2000);
          }
        });
      });
    }
  }
}
